import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class Menu {

	static popup: any;
}
